var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('form', {
    ref: "form",
    attrs: {
      "name": "form_auth",
      "method": "post",
      "action": _vm.popupUrl,
      "target": "_self"
    }
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "tc",
      "value": "kcb.oknm.online.main.popup.cmd.P941_CertChoiceCmd"
    }
  }), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "idcf_mbr_com_cd"
    },
    domProps: {
      "value": _vm.siteCode
    }
  }), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "svc_tkn"
    },
    domProps: {
      "value": _vm.svcTkn
    }
  })]);
}
var staticRenderFns = []

export { render, staticRenderFns }